import { SET_ERROR_LOG_PARAMETER } from "./ComponentErrorLogType"

const setErrorLogParameter = (value: any) => {

  return{
    type:SET_ERROR_LOG_PARAMETER,
    value
  }
}

export {
    setErrorLogParameter
    
}
